import React from 'react';
import {useTranslation} from 'react-i18next';

import {
  Modal,
  ModalActions,
  ModalCancelButton,
  ModalContent,
  ModalHeader,
  ModalSubmitButton,
  showModal,
  showNewNotification,
} from '@edna/components';

import {ModalCenterImage, Text} from 'src/components/primitives';
import {CleaningImage} from 'src/images';

import {useDeleteAvailableTariffMutation} from '../api';
import {TAvailableTariff} from '../definitions';

const DeleteTariffModal = React.memo<{closeModal: TEmptyFunction; tariff: TAvailableTariff}>(
  ({closeModal, tariff}) => {
    const {t} = useTranslation();

    const [deleteTariff, {isLoading}] = useDeleteAvailableTariffMutation();

    const handleSubmit = React.useCallback(async () => {
      try {
        await deleteTariff({id: tariff.id, version: tariff.version}).unwrap();
        closeModal();
        showNewNotification({
          type: 'SUCCESS',
          message: t('Tariffs:successNotifications.deleteTariff', {name: tariff.name}),
        });
      } catch (e) {}
    }, [tariff, closeModal]);

    return (
      <Modal width="430px">
        <ModalHeader>{t('Tariffs:deleteModal.title')}</ModalHeader>
        <ModalContent>
          <Text secondary>{t('Tariffs:deleteModal.subtitle')}</Text>
        </ModalContent>
        <ModalCenterImage as={CleaningImage} />
        <ModalActions>
          <ModalCancelButton onClick={closeModal}>{t('Common:button.cancel')}</ModalCancelButton>
          <ModalSubmitButton onClick={handleSubmit} disabled={isLoading} loading={isLoading}>
            {t('Common:button.delete')}
          </ModalSubmitButton>
        </ModalActions>
      </Modal>
    );
  },
);

DeleteTariffModal.displayName = 'DeleteTariffModal';

export const showDeleteTariffModal = (tariff: TAvailableTariff) =>
  showModal((closeModal) => <DeleteTariffModal closeModal={closeModal} tariff={tariff} />);
